document.addEventListener("DOMContentLoaded", function () {

  const heroSections = document.querySelectorAll(".tp-hero");

  heroSections.forEach(function (hero) {

    const buildButton = hero.querySelector("[data-build-gift-box]");

    if (!buildButton) return;

    /*
     * Build Your Gift Box is intentionally a normal
     * Shopify page link.
     *
     * Example:
     * /pages/corporate-gifting
     *
     * No popup is used.
     */

    buildButton.addEventListener("click", function (event) {

      const targetUrl = buildButton.getAttribute("href");

      if (!targetUrl || targetUrl === "#") {
        event.preventDefault();

        console.warn(
          "TRU PAHADI: Please select a page for the Build Your Gift Box button in Theme Customizer."
        );

        return;
      }

      /*
       * Small loading state
       */
      buildButton.classList.add("is-loading");

    });

  });

});